module.exports = __webpack_public_path__ + "img/1700m.6417abae.png";